"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var links = exports.links = "\nlinks {\n  key\n  type\n  title\n  url\n  hide\n  hoverText\n  prefix\n  append\n  dtm {\n    eventType\n    eventAction\n    eventAsset\n    type\n    tag\n  }\n}\n";

var encodedLinks = exports.encodedLinks = "\nencodedLinks {\n  key\n  type\n  title\n  url\n  hoverText\n  prefix\n  append\n  dtm {\n    eventType\n    eventAction\n    eventAsset\n    type\n    tag\n  }\n}\n";